import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownTreeComponent } from './dropdowntree.component';
/**
 * NgModule definition for the DropDownTree component.
 */
export class DropDownTreeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        DropDownTreeComponent
    ],
    exports: [
        DropDownTreeComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DropDownTreeModule_tsickle_Closure_declarations() {
/** @type {?} */
DropDownTreeModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownTreeModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
